function popup() {
	const popupElement = document.getElementById('popup');
	const closeButton = popupElement?.querySelector('.close');
	const cookieName = 'popup_shown';

	function hasCookie(name) {
		return document.cookie.split('; ').some(cookie => cookie.startsWith(`${name}=`));
	}

	function setCookie(name, value, days) {
		const expires = new Date(Date.now() + days * 86400000).toUTCString();
		document.cookie = `${name}=${value}; expires=${expires}; path=/`;
	}

	if (!popupElement || popupElement.dataset.show === ' no ') {
		return;
	}

	if (!hasCookie(cookieName)) {
		document.body.style.overflow = 'hidden';
		popupElement.classList.add('show');

		if (closeButton) {
			closeButton.addEventListener('click', () => {
				setCookie(cookieName, 'true', 30);
				document.body.style.overflow = '';
				popupElement.classList.remove('show');
			});
		}
	}
}

export {popup};